import Sidebar from "../../components/Common/Sidebar";
import { AiProductsList } from "../../components/_pages/AiProducts";

const AiProducts = () => {
  return (
    <>
      <Sidebar />
      <AiProductsList />
    </>
  );
};

export default AiProducts;
